<!--
 * @Description: 用户选择弹出框组件
-->
<template>
    <van-tabs :color="color" v-model="active">
        <van-tab title="已绑定户号">
            <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onListLoad"
            class="course-more__content"
            :immediate-check="false"
            >
                <div class="user-list" v-for="(user, i) in userNoList" :key="i">
                    <div v-show="i===0" style="height:21px;"></div>
                    <user-item-select :user="user" @selectClick="onSelectClick"></user-item-select>
                    <div style="height:21px;"></div>
                </div>
            </van-list>
        </van-tab>
        <van-tab title="未绑定户号查询" v-if="isquery === 1 || isquery != 0">
            <div class="search-bar">
                <div class="bar-con">
                    <van-field
                            style="width:49%;"
                            v-model="userno"
                            label="用户号"
                            placeholder=""/>
                    <van-field style="width:49%;" v-model="username" label="户名" placeholder=""/>
                </div>
                <div class="bar-btn" @click="getuserinfo()">
                    查询
                </div>
            </div>
            <div class="user-list" v-show="userInfo">
                <div style="height:21px;"></div>
                <user-item-select :user="userInfo" @selectClick="onSelectClick" v-show="userInfo"></user-item-select>
            </div>
        </van-tab>
    </van-tabs>
</template>

<script>
    import UserItemSelect from '@/components/UserItemSelect.vue'

    export default {
        components: {
            UserItemSelect,
        },
        props: {
            userList: Array,
            isquery: {type: Number, default: 0}
        },
        data() {
            return {
                active: 0,
                userno: '',
                username: '',
                userInfo: {},
                userNoList: [],
                pageindex:1,
                pagesize:10,
                loading:false,
                finished:false,
                refreshing:false,
                color:'#1677FF',
            }
        },
        created() {
            if(this.isquery === 1){
                this.color = '#1677FF'
            }else{
                this.color = '#f8f8f8'
            }
            this.getuserlist();
        },
        methods: {
            getuserinfo() {
                if (this.userno === '') {
                    this.$toast('请输入用户号')
                    return;
                }
                if (this.username === '') {
                    this.$toast('请输入户名')
                    return;
                }
                let userInfo = {}
                this.$comm.getUserInfo(this.userno, this.username).then(res => {
                    if (res) {
                        userInfo['fuserno'] = res.yhh
                        userInfo['fname'] = res.fname
                        userInfo['ffixaddr'] = res.zbwz
                        userInfo['fee'] = 0
                    } else {
                        userInfo = null;
                        this.$toast('查无数据')
                    }
                    this.userInfo = userInfo
                })
            },
            onListLoad () {
                setTimeout(() => {
                    if (this.refreshing) {
                        this.refreshing = false
                        this.pageindex = 2
                        console.log('加载》》》》》》》》》')
                    } else {
                        this.pageindex++
                    }
                    this.getuserlist(true)
                }, 1000)
            },
            getuserlist() {
                this.$http.post(this.$api.userList, {pageindex:this.pageindex,pagesize:this.pagesize}).then(res => {
                  if (res.code==='000') {
                    this.userNoList = this.userNoList.concat(res.data)
                    if (this.userNoList.length >= parseInt(res.totalcount)) {
                        this.finished = true
                    }
                    this.$clear()
                  }else{
                      this.$toast(res.msg)
                  }
                })
            },
            onSelectClick(user) {
                this.$emit('onSelectClick', user)
            },
        },
    }
</script>

<style lang="less" scoped>
    .user-list {
        background: rgba(255, 255, 255, 1);
        padding: 0px 16px;
    }

    .search-bar {
        background: rgba(255, 255, 255, 1);
        padding: 0 16px;
        height: 44px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .bar-con {
            width: calc(~"100% - 64px");
            display: flex;
            justify-content: space-between;

            /deep/ .van-field__body {
                padding: 0 7px;
            }

            /deep/ .van-cell--required::before {
                left: -8px;
            }
        }

        .bar-btn {
            width: 64px;
            text-align: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2C82C9;
            line-height: 40px;
        }

        /deep/ .van-cell.van-field {
            padding: 0;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(33, 33, 33, 1);

            .van-cell__title.van-field__label {
                width: 48px;
            }

            .van-cell__value.van-field__value {
                width: 90px;
                height: 27px;
                background: #F4F4F4;
                border-radius: 3px;
            }
        }
    }
</style>